import { LightAlert } from 'components/shared/LightAlert';
import { useWorkflowErrorsUtils } from 'hooks/useWorkflowErrorsUtils';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { TradeAuthorizationErrorsProps } from './TradeAuthorizationErrors.connect';
import { connectTradeAuthorizationErrors } from './TradeAuthorizationErrors.connect';

export const Component: FC<TradeAuthorizationErrorsProps> = ({
  productSubtype,
  rejections,
  useRejectionCode,
  hasTimeout,
}) => {
  const { formatMessage } = useIntl();
  const { getWorkflowErrorMessage } = useWorkflowErrorsUtils();

  const errors = useMemo(() => {
    if (hasTimeout) {
      return [formatMessage({ id: 'quote.errorMessages.tradeAuthorizationTimeout' })];
    }
    if ((rejections?.length ?? 0) === 0) {
      return [formatMessage({ id: 'quote.errorMessages.tradeAuthorizationFailed' })];
    }
    return rejections.map(r => getWorkflowErrorMessage(r, useRejectionCode, productSubtype));
  }, [rejections, formatMessage, useRejectionCode, productSubtype, getWorkflowErrorMessage, hasTimeout]);
  return (
    <div data-e2e="tradeAuth-rejections">
      {errors.map((error, idx) => (
        <LightAlert key={idx} severity="danger" e2e="tradeAuth-rejection">
          {error}
        </LightAlert>
      ))}
    </div>
  );
};

Component.displayName = 'TradeAuthorizationErrors';
export const TradeAuthorizationErrors = connectTradeAuthorizationErrors(Component);
